import { PDFDocument } from "pdf-lib";

const EXTENSOES_IMAGEM = ["png", "jpg", "jpeg", "webp", "gif", "bmp"];
const LADO_MAXIMO_PX = 2400; // fotos de celular têm 4000px+ — limita pra não gerar PDFs gigantes
const LADO_MAXIMO_PAGINA = 1000; // pontos de PDF da maior dimensão da página

export function ehImagemAssinavel(nome = "") {
    return EXTENSOES_IMAGEM.includes(nome.split(".").pop()?.toLowerCase());
}

export function nomeSemExtensao(nome = "") {
    const i = nome.lastIndexOf(".");
    return i > 0 ? nome.slice(0, i) : nome;
}

/**
 * Converte uma imagem (Blob/File) num PDF de uma página do tamanho da imagem, pra poder passar pelo
 * mesmo fluxo de assinatura/rateio dos PDFs. Passa sempre por um canvas: aplica a orientação EXIF
 * (fotos de celular tiradas em pé, senão, ficariam deitadas) e uniformiza formatos que o pdf-lib
 * não embute direto (webp, gif, bmp).
 */
export async function imagemParaPdf(blobImagem) {
    const bitmap = await createImageBitmap(blobImagem, { imageOrientation: "from-image" });
    const escala = Math.min(1, LADO_MAXIMO_PX / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bitmap.width * escala);
    canvas.height = Math.round(bitmap.height * escala);
    const ctx = canvas.getContext("2d");
    // Fundo branco: PNG com transparência viraria preto ao ir pra JPEG.
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close?.();

    // PNG (capturas de tela, texto) segue em PNG pra não perder nitidez; o resto vira JPEG.
    const ehPng = blobImagem.type === "image/png";
    const saida = await new Promise(resolve => canvas.toBlob(resolve, ehPng ? "image/png" : "image/jpeg", 0.92));

    const pdf = await PDFDocument.create();
    const bytesImagem = await saida.arrayBuffer();
    const imagem = ehPng ? await pdf.embedPng(bytesImagem) : await pdf.embedJpg(bytesImagem);
    const fator = Math.min(1, LADO_MAXIMO_PAGINA / Math.max(canvas.width, canvas.height));
    const largura = canvas.width * fator;
    const altura = canvas.height * fator;
    const pagina = pdf.addPage([largura, altura]);
    pagina.drawImage(imagem, { x: 0, y: 0, width: largura, height: altura });

    return new Blob([await pdf.save()], { type: "application/pdf" });
}
